"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                AppBarSearch_Collapse: "Collapse action search",
                AppBarSearch_HelpText: "(Ctrl+')",
                AppBarSearch_PlaceHolderText: "Perform an action",
                AppBarSearch_Tooltip: "Perform an action",
            },
        });
        /**
         * Framework class for AppBarSearchField control
         */
        var AppBarSearchField = /** @class */ (function (_super) {
            __extends(AppBarSearchField, _super);
            function AppBarSearchField() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            AppBarSearchField.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                var searchFieldElement = this.SearchFieldElement();
                $dyn.observe($dyn.options(function () {
                    return { resultData: _this.ResultList, selectedIndex: _this.SelectedIndex };
                }, this.Updating), function (option) {
                    var resultList = $dyn.value(option.resultData);
                    if (resultList.length === 0) {
                        searchFieldElement.setAttribute("aria-label", $dyn.label("Search_NoResultsMessage"));
                    }
                });
                this.ShowResultPicker.valueChanged.subscribe(function () {
                    if (searchFieldElement && $dyn.value(_this.ShowResultPicker)) {
                        _this.SearchField().$inputElement.attr("aria-controls", $dyn.value(_this.Id) + "_listbox");
                        _this.SearchField().$inputElement.attr("aria-activedescendant", $dyn.value(_this.Id) + "_listbox_item" + $dyn.value(_this.SelectedIndex));
                    }
                    else if (searchFieldElement) {
                        // picker was open but flyout closed we need to cleanup
                        _this.cleanUpPicker();
                    }
                });
            };
            /**
             * Event handler that is executed when children of the AppBarSearchField have been databound.
             * @description Used to update aria-labels.
             * @internal
             */
            AppBarSearchField.prototype.postDataBindChildren = function () {
                // After action search is databound, find the input element and update its aria tag
                var inputElement = this.SearchFieldElement().getElementsByClassName("field")[0];
                inputElement.setAttribute("aria-label", $dyn.label("AppBarSearch_PlaceHolderText"));
                inputElement.setAttribute("aria-controls", $dyn.value(this.Id) + "_listbox");
                inputElement.setAttribute("aria-activedescendant", null);
            };
            /**
             * Displays AppBarSearchField control.
             * @internal
             */
            AppBarSearchField.prototype.showField = function () {
                this._getSearchIcon().tabIndex = -1;
                this.SearchFieldShown(true);
                this.focusElementHandled = false;
                this.Root.setControlFocus(this.element, this.Root.ActiveElement());
            };
            /**
             * The click event handler for the search icon.
             * @internal
             */
            AppBarSearchField.prototype.searchIconClicked = function () {
                if ($dyn.value(this.SearchFieldShown)) {
                    this.hideField();
                }
                else {
                    this.showField();
                }
            };
            AppBarSearchField.prototype.clickItem = function (index) {
                var resultList = $dyn.value(this.ResultList);
                if (index > resultList.length || !resultList[index].Enabled) {
                    return;
                }
                this.SelectedIndex(index);
                var listItem = resultList[index];
                $dyn.telemetry.addActionSearchEvent(this.Root, this.lastSearchedQuery, index, listItem.Name, listItem.Path + " > " + listItem.Label);
                this.recordTelemetryOnClose = false;
                var event;
                if (listItem.Command) {
                    // Issue a client side command to see if we should continue with the normal action search click.
                    event = $.Event(listItem.Command);
                    $(this.element).trigger(event);
                }
                // Command could have been handled client side already, don't call the action search click in that case.
                if (!event || !event.isDefaultPrevented()) {
                    var lastActiveControl = $dyn.context(this.Root.ActiveElementInMainFormContainer());
                    if (lastActiveControl) {
                        $dyn.callFunction(this.Root.UpdateLastSelectedControl, this.Root, [lastActiveControl.Name]);
                    }
                    $dyn.callFunction(this.Root.ExecuteActionSearchClick, this.Root, listItem.Name);
                }
                this.closeResultPicker(null, true);
                this.hideField();
            };
            /**
             * closes the expanded search input if the flyout is not open
             * @param evt The focus out event
             */
            AppBarSearchField.prototype.focusout = function (evt) {
                // flyout manages the focus out normally
                // is the flyout not open
                if (!this.focusElementHandled && evt.target === this.SearchFieldElement().getElementsByClassName("field")[0] && !$(evt.relatedTarget).parents(".actionSearch-results").length) {
                    this.hideField();
                    this._getSearchIcon().focus();
                }
            };
            /**
             * Cleans up after the picker is closed
             * @internal
             */
            AppBarSearchField.prototype.cleanUpPicker = function () {
                // picker was open but flyout closed with esc
                if ($dyn.value(this.SearchFieldShown)) {
                    this.focusElementHandled = true;
                    this.closeResultPicker(null, true);
                }
            };
            AppBarSearchField.prototype.TextChanged = function (args) {
                // In IE, placeholder text is cleared on focus. We are using a pseudo placeholder in this case.
                // When a key is typed, hide the placeholder text for the pseudo-placeholder.
                if (args[0] !== "") {
                    this.element.parentElement.classList.add("actionSearch-hidePlaceholder");
                }
                // this context is the input control inside of the ActionSearch control
                var searchField = this.SearchField;
                searchField.ProcessResults = true;
                var searchText = this.$inputElement[0].value;
                if (searchText) {
                    var searchCallback = function (results) {
                        var searchElement = searchField.SearchField();
                        var currentSearchText = searchElement.$inputElement[0].value;
                        if (searchField.ProcessResults && currentSearchText) {
                            if (results) {
                                var resultsParsed = JSON.parse(results);
                                if (resultsParsed.length) {
                                    searchField.ResultList(resultsParsed);
                                }
                                else {
                                    searchField.ResultList([]);
                                }
                            }
                            else {
                                searchField.ResultList([]);
                            }
                            searchField.openResultPicker();
                        }
                    };
                    searchField.recordTelemetryOnClose = true;
                    searchField.lastSearchedQuery = this.$inputElement[0].value;
                    $dyn.callFunction(this.Root.ExecuteActionSearch, this, [this.$inputElement[0].value], searchCallback);
                }
                else {
                    // Value is blank. Flyout should get closed
                    searchField.ShowResultPicker(false);
                    searchField.ResultList([]);
                    searchField.element.classList.remove("actionSearch-hidePlaceholder");
                }
            };
            /**
             * Closes the search results flyout
             * @param evt The event for which this handler is run.
             * @param clearResultList Whether to clear the results list or not
             */
            AppBarSearchField.prototype.closeResultPicker = function (evt, clearResultList) {
                if (clearResultList === void 0) { clearResultList = false; }
                this.ShowResultPicker(false);
                if (clearResultList) {
                    this.ResultList([]);
                }
                // remove attributes
                var inputElement = this.SearchFieldElement().getElementsByClassName("field")[0];
                inputElement.setAttribute("aria-label", $dyn.label("AppBarSearch_PlaceHolderText"));
                inputElement.removeAttribute("aria-controls");
                inputElement.removeAttribute("aria-activedescendant");
                // If closing for any other reason besides pressing esc or tab, set focus to last active element outside of app bar
                if (!this.focusElementHandled) {
                    this.returnFocus();
                }
            };
            /**
             * Selects the next item in the search results list.
             * @description Used in Down arrow key handler.
             * @internal
             */
            AppBarSearchField.prototype.nextItem = function () {
                var currentIndex = $dyn.value(this.SelectedIndex);
                var nextIndex = currentIndex;
                var items = $dyn.value(this.ResultList);
                nextIndex++;
                if (items && nextIndex >= items.length) {
                    nextIndex = 0;
                }
                this.SelectedIndex(nextIndex);
                this.scrollSelectedResultIntoView(nextIndex);
                this.SearchField().$inputElement.attr("aria-activedescendant", $dyn.value(this.Id) + "_listbox_item" + nextIndex);
            };
            /**
             * Selects the previous item in the search results list.
             * @description Used in Up arrow key handler.
             * @internal
             */
            AppBarSearchField.prototype.previousItem = function () {
                var currentIndex = $dyn.value(this.SelectedIndex);
                var previousIndex = currentIndex;
                var items = $dyn.value(this.ResultList);
                previousIndex--;
                if (previousIndex < 0 && items) {
                    previousIndex = items.length - 1;
                }
                this.SelectedIndex(previousIndex);
                this.scrollSelectedResultIntoView(previousIndex);
                this.SearchField().$inputElement.attr("aria-activedescendant", $dyn.value(this.Id) + "_listbox_item" + previousIndex);
            };
            AppBarSearchField.prototype.SearchFieldElement = function () {
                if (!this._searchFieldElement) {
                    this._searchFieldElement = this.element.getElementsByClassName("actionSearch-field")[0];
                }
                return this._searchFieldElement;
            };
            /**
             * Hides AppBarSearchField control.
             */
            AppBarSearchField.prototype.hideField = function () {
                this._getSearchIcon().tabIndex = 0;
                this.SearchFieldShown(false);
                this.SearchField().$inputElement.val("");
                this.SearchField().$inputElement.removeAttr("aria-controls");
                this.SearchField().$inputElement.removeAttr("aria-activedescendant");
                this.SearchFieldElement().parentElement.classList.remove("actionSearch-hidePlaceholder");
                if (this.recordTelemetryOnClose) {
                    this.recordTelemetryOnClose = false;
                    $dyn.telemetry.addActionSearchEvent(this.Root, this.lastSearchedQuery, -1);
                }
            };
            /**
             * @returns The AppBar search icon button
             */
            AppBarSearchField.prototype._getSearchIcon = function () {
                if (!this._searchIconElement) {
                    this._searchIconElement = this.element.getElementsByClassName("actionSearch-icon")[0];
                }
                return this._searchIconElement;
            };
            /**
             * Returns focus to the last active element on the form outside of the ApplicationBar.
             */
            AppBarSearchField.prototype.returnFocus = function () {
                if (this.Root) {
                    var newActive = $dyn.context(this.Root.ActiveElementInMainFormContainer());
                    if (newActive) {
                        this.focusElementHandled = true; // so the focus out doesnt over ride
                        this.hideField();
                        $dyn.setValue(this.Root, "ActiveControl", newActive.Name);
                    }
                }
            };
            return AppBarSearchField;
        }(controls.CombinedSearchField));
        controls.AppBarSearchField = AppBarSearchField;
        // tslint:disable-next-line:no-string-literal
        AppBarSearchField.prototype["recordTelemetryOnClose"] = false;
        $dyn.ui.addObservablePropertiesToPrototype(AppBarSearchField.prototype, {
            SearchFieldShown: false,
        });
        // tslint:disable:object-literal-sort-keys
        var appBarSearchFieldShortcuts = {
            Enter: {
                Keys: { keyCode: $dyn.ui.KeyCodes.enter },
                Handler: function () {
                    if ($dyn.length(this.ResultList) > 0) {
                        // Click the specified button for the selected item
                        if ($dyn.value(this.ShowResultPicker)) {
                            var selectedIndex = $dyn.value(this.SelectedIndex);
                            if ($dyn.value(this.ResultList)[selectedIndex].Enabled) {
                                this.ProcessResults = false;
                                // If the drop down is open, call the tell me action server command for the specified action.
                                this.clickItem(selectedIndex);
                                this.hideField();
                            }
                        }
                        else {
                            this.openResultPicker();
                        }
                    }
                    else {
                        this.showField();
                    }
                },
                RecordTelemetry: false,
                Description: function () {
                    var label = "";
                    if (!$dyn.value(this.SearchFieldShown)) {
                        label = $dyn.label("GlobalSearchPlaceholder_Action");
                    }
                    else if ($dyn.length(this.ResultList) > 0) {
                        if ($dyn.value(this.ShowResultPicker)) {
                            label = $dyn.label("Search_PerformAction");
                        }
                        else {
                            label = $dyn.label("Search_ViewResults");
                        }
                    }
                    return label;
                }
            },
            Esc: {
                Keys: { keyCode: [$dyn.ui.KeyCodes.esc, $dyn.ui.KeyCodes.tab] },
                Handler: function (evt) {
                    if ($dyn.value(this.SearchFieldShown)) {
                        // is picker open? and esc - just close it
                        if ($dyn.value(this.ShowResultPicker()) && evt.keyCode === $dyn.ui.KeyCodes.esc) {
                            this.cleanUpPicker();
                        }
                        else {
                            // cleanup and set focus to button
                            if ($dyn.value(this.ShowResultPicker())) {
                                this.cleanUpPicker();
                            }
                            this.hideField();
                            this._getSearchIcon().focus();
                        }
                        return true;
                    }
                    return false;
                },
                RecordTelemetry: false,
                ShowToUser: function () {
                    return ($dyn.value(this.ShowResultPicker) || $dyn.value(this.SearchFieldShown));
                },
                Description: function () {
                    var label = "";
                    if ($dyn.value(this.ShowResultPicker)) {
                        label = $dyn.label("Search_Close");
                    }
                    else if ($dyn.value(this.SearchFieldShown)) {
                        label = $dyn.label("AppBarSearch_Collapse");
                    }
                    return label;
                }
            }
        };
        AppBarSearchField.prototype.Shortcuts = $dyn.extendPrototype(AppBarSearchField.prototype.Shortcuts, appBarSearchFieldShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=AppBarSearchField.js.map
